import './SpecialDayOff.scss';
import SpecialDayOffHeader from '../../components/SpecialDayOff/SpecialDayOffHeader';
import SpecialDayOffInfoTab from '../../components/SpecialDayOff/SpecialDayOffInfoTab';
import SpecialDayOffMyRequests from '../../components/SpecialDayOff/SpecialDayOffMyRequests';
import SpecialDayOffRequestForm from '../../components/SpecialDayOff/SpecialDayOffRequestForm';
import { useEffect, useState } from 'react';
import { useSpecialDayOffProvider } from '../../providers/SpecialDayOffProvider';
import { useNotifications } from '../../providers/Notifications';
import { sdoStatusType } from '../../components/SpecialDayOff/SpecialDayOffHelper';
import Loader from '../../components/Loader/Loader';
import { useFreezePeriod } from '../../providers/FreezePeriod';
import { FreezePeriodInterface } from '../../models/FreezePeriodInterface';
import { useHistory } from 'react-router-dom';
import { useAdminAppControl } from '../../providers/AdminAppControlProvider';

export default function SpecialDayOff() {
  const specialDayOffContext = useSpecialDayOffProvider();
  const [toggleSdoFormVisible, setToggleSdoFormVisible] = useState(false);
  const [editSdoForm, setEditSdoForm] = useState(false);
  const NotificationsContext = useNotifications();
  const [requestedSdoDates, setRequestedSdoDates] = useState<any>({});
  const [notificationVisible, setNotificationVisible] = useState({
    approvedVisible: false,
    conflictVisible: false
  });
  const [sdoConflictRequest, setSdoConflictRequest] = useState(false);
  const freezePeriodContext = useFreezePeriod();
  const [currentPairingMonthData, setCurrentPairingMonthData] =
    useState<FreezePeriodInterface>();

  useEffect(() => {
    setNotificationVisible({ approvedVisible: false, conflictVisible: false });
    specialDayOffContext.getSdoInfoTabData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { featureState, isLoading: isFeatureLoading } = useAdminAppControl();

  const history = useHistory();
  const isSDOKillSwitchEnabled = featureState.find(
    (item) => item.moduleId === 9 && item.isEnabled
  );

  useEffect(() => {
    //If SDO Kill Switch is enabled then redirect to home page.
    if (!isFeatureLoading && isSDOKillSwitchEnabled) {
      history.push('/');
    }
  }, [isSDOKillSwitchEnabled, isFeatureLoading, history]);

  useEffect(() => {
    if (
      !freezePeriodContext.freezePeriodData.pairingFreeze ||
      freezePeriodContext.loading
    ) {
      return;
    }
    setCurrentPairingMonthData({
      ...freezePeriodContext.freezePeriodData.pairingFreeze.filter(
        (val) => val
      )[0]
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [freezePeriodContext]);

  useEffect(() => {
    if (
      !specialDayOffContext.sdoInfoTabData.sdoYear &&
      !specialDayOffContext.sdoInfoTabData.sdoMonth
    ) {
      return;
    }
    specialDayOffContext.getSdoMyRequestData({
      year: specialDayOffContext.sdoInfoTabData.sdoYear
    });
    NotificationsContext.getNotifications();
    specialDayOffContext.getSdoCalendarData({
      year: specialDayOffContext.sdoInfoTabData.sdoYear,
      month: String(specialDayOffContext.sdoInfoTabData.sdoMonth)
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [specialDayOffContext.sdoInfoTabData]);

  useEffect(() => {
    setRequestedSdoDates({});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [specialDayOffContext.sdoMyRequestData]);

  useEffect(() => {
    if (
      !(
        NotificationsContext?.notifications?.result &&
        NotificationsContext?.notifications?.result.length
      )
    )
      return;

    if (NotificationsContext?.notifications?.result?.length >= 1) {
      NotificationsContext.notifications.result.forEach((msg) => {
        if (msg.module === 'sdo.response') {
          if (
            msg.message.description.toLocaleLowerCase().includes('approved')
          ) {
            setNotificationVisible({
              approvedVisible: true,
              conflictVisible: false
            });
          }
          NotificationsContext.updateNotificationViewed(
            msg.year,
            msg.month,
            'sdo.response',
            msg.notificationId
          );
        }
        if (msg.module === 'sdo.revoked') {
          NotificationsContext.updateNotificationViewed(
            msg.year,
            msg.month,
            'sdo.revoked',
            msg.notificationId
          );
        }
        if (msg.module === 'sdo.conflict') {
          setNotificationVisible({
            approvedVisible: false,
            conflictVisible: true
          });
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [NotificationsContext.notifications]);

  // To edit the requested Special Day Off Request
  const editSpecialDayOffRequest = (req) => {
    setRequestedSdoDates({
      fromDate: req.requestedFromDt,
      toDate: req.requestedToDt,
      transactionId: req.transactionId
    });
    setToggleSdoFormVisible(true);
    setEditSdoForm(true);
    if (req.status === sdoStatusType.CONFLICT) setSdoConflictRequest(true);
  };

  // const blockMonthYear = blockDates.start ? getEasternTime(blockDates.start).toLocaleString('en-us', { month: 'long' })+' '+ getEasternTime(blockDates.start).getFullYear() : 'N/A';

  return specialDayOffContext.sdoInfoTabLoading ||
    specialDayOffContext.sdoMyRequestLoading ||
    specialDayOffContext.sdoCalLoading ||
    isFeatureLoading ? (
    <Loader />
  ) : (
    <div className="sdo__container">
      <SpecialDayOffHeader toggleSdoFormVisible={toggleSdoFormVisible} />
      <SpecialDayOffInfoTab />
      {toggleSdoFormVisible ? (
        <SpecialDayOffRequestForm
          setToggleSdoFormVisible={setToggleSdoFormVisible}
          editSdoForm={editSdoForm}
          requestedSdoDates={requestedSdoDates}
          setRequestedSdoDates={setRequestedSdoDates}
          sdoConflictRequest={sdoConflictRequest}
          currentPairingMonthData={currentPairingMonthData}
        />
      ) : (
        <SpecialDayOffMyRequests
          setToggleSdoFormVisible={setToggleSdoFormVisible}
          setEditSdoForm={setEditSdoForm}
          handleEditSpecialDayOffRequest={editSpecialDayOffRequest}
          notificationVisible={notificationVisible}
          setNotificationVisible={setNotificationVisible}
          currentPairingMonthData={currentPairingMonthData}
        />
      )}
    </div>
  );
}
